import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components/macro';
import { Link, useLocation } from 'react-router-dom';
import {
  TABLET_WIDTH,
  MOBILE_WIDTH,
  FOOTER_HEIGHT,
  HEADER_HEIGHT,
} from '../../constants/dims';
import routes from '../../constants/routes';
import PreferencesContext from '../../contexts/preferences';
//import AppStore from './AppStore';

const Container = styled.div`
  width: 100%;
  height: ${(props) => (props.inGame ? 90 : FOOTER_HEIGHT)}px;
  position: relative;
  top: ${HEADER_HEIGHT}px;
  display: flex;
  flex-direction: column;
  justify-content: ${(props) =>
    props.isOnGetStarted ? 'space-around' : 'space-between'};
  align-items: center;
  color: ${(props) => props.theme.footer.text};
  background-color: ${(props) => props.theme.footer.backgroundColor};
  padding: 20px;
  box-sizing: border-box;

  @media screen and (max-width: ${MOBILE_WIDTH}px) {
    top: 0;
    height: auto;
  }

  & > div.items {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    flex-wrap: wrap;
    max-width: ${TABLET_WIDTH}px;

    @media screen and (max-width: ${MOBILE_WIDTH}px) {
      justify-content: center;
    }
  }

  & > .copyright {
    font-size: 0.8em;
    font-style: italic;
  }

  & > .download {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 20px 0;
    font-size: 0.8em;
    font-weight: bold;
    text-transform: uppercase;

    & > div {
      margin-bottom: 12px;
    }
  }
`;

const LinkWrapper = styled.div`
  &,
  & > * {
    font-size: 12.75px;
    text-transform: uppercase;
    padding-right: 12px;
    white-space: nowrap;
    margin-bottom: 12px;
    box-sizing: border-box;

    &:link,
    &:visited {
      color: inherit;
    }

    &:last-child {
      padding-right: 0;
    }

    & .smaller {
      vertical-align: super;
      font-size: 0.7em;
      text-transform: none;
    }
  }
`;

const Item = ({ inGame, to, children, ...props }) => {
  if (inGame) {
    return (
      <LinkWrapper {...props}>
        <Link to={to}>{children}</Link>
      </LinkWrapper>
    );
  }

  return (
    <LinkWrapper {...props}>
      <a href={to}>{children}</a>
    </LinkWrapper>
  );
};

const Footer = () => {
  const { inGame } = useContext(PreferencesContext);
  const { pathname } = useLocation();
  const [isOnGetStarted, setIsOnGetStarted] = useState(
    /getStarted$/.test(pathname)
  );
  //const [isOnLanding, setIsOnLanding] = useState(pathname === '/');

  useEffect(() => {
    setIsOnGetStarted(/getStarted$/.test(pathname));
    //setIsOnLanding(pathname === '/');
  }, [pathname]);

  return (
    <Container isOnGetStarted={isOnGetStarted} inGame={inGame}>
      <div className="items">
        {!inGame && (
          <React.Fragment>
          <Item to={"https://brainquakegames.com/bqdailypuzzle/index.html"}>Daily Puzzle</Item>
            <Item to={routes.about}>About</Item>
            <Item to={routes.team}>Team</Item>
            <Item to={routes.research}>Research</Item>
            <Item to={routes.privacyPolicy}>
              Privacy Policy{' '}
              <span className="smaller">Updated on 1/1/2020</span>
            </Item>
            <Item to={routes.tos}>Terms</Item>
            <Item to={routes.help}>Help</Item>
            <Item to={routes.contact}>Contact</Item>
            <Item to={routes.shop}>Shop</Item>
            <Item to={"https://brainquake.medium.com/"}>Blog</Item>
          </React.Fragment>
        )}

        {inGame && (
          <React.Fragment>
            <Item to="uniwebview://restore_purchases">Restore Purchases</Item>
            <Item to={`.${routes.privacyPolicy}`}>
              Privacy Policy{' '}
              <span className="smaller">Updated on 1/1/2020</span>
            </Item>
            <Item to={`.${routes.tos}`}>Terms</Item>
          </React.Fragment>
        )}
      </div>

      {/*{!isOnGetStarted && !isOnLanding && !inGame && (
        <AppStore
          className="download"
          label="Download BrainQuake!"
          width={135}
        />
      )}*/}

      <div className="copyright">
        All Content &copy; 2013-{new Date().getFullYear()} BrainQuake, All
        Rights Reserved. Wuzzit&trade; is a registered trademark of BrainQuake
        Inc.
      </div>
    </Container>
  );
};

export default Footer;
